import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Log to console for debugging
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 flex items-center justify-center p-4">
          <div className="max-w-lg w-full bg-slate-800/80 border border-orange-500/30 rounded-2xl p-8 text-center shadow-2xl">
            <div className="flex justify-center mb-6">
              <div className="bg-orange-500/20 p-4 rounded-full">
                <AlertTriangle className="w-12 h-12 text-orange-400" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-white mb-3">
              Oops! Something went wrong
            </h1>
            <p className="text-orange-200 mb-6">
              An unexpected error occurred. Please try reloading the page.
              If the problem persists, contact us at{" "}
              <a href="mailto:support@wuma.photo" className="text-orange-400 underline">
                support@wuma.photo
              </a>
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
              <button
                onClick={this.handleReload}
                className="flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
              >
                <RefreshCw className="w-5 h-5" />
                Reload Page
              </button>
              <button
                onClick={this.handleGoHome}
                className="flex items-center justify-center gap-2 bg-slate-700 hover:bg-slate-600 text-white px-6 py-3 rounded-lg font-medium transition-colors"
              >
                Go to Home
              </button>
            </div>

            {/* Error details for debugging - collapsible */}
            <details className="text-left bg-slate-900/50 rounded-lg p-3 mt-4">
              <summary className="text-orange-300 text-sm cursor-pointer font-medium">
                Technical details (for support)
              </summary>
              <pre className="text-red-300 text-xs mt-2 overflow-x-auto whitespace-pre-wrap break-words max-h-40 overflow-y-auto">
                {this.state.error?.toString()}
                {this.state.errorInfo?.componentStack}
              </pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
